import React, { Component } from 'react';
import { mediaQueries } from 'Theme';
import cxs from 'cxs/component';
class Scroll extends Component {
    render() {
        return React.createElement(StyledScroll, Object.assign({}, this.props));
    }
}
export default Scroll;
const StyledScroll = cxs('div')({
    // flex: 1,
    display: 'block',
    overflowY: 'auto',
    [mediaQueries.mobile]: {
    // height: '100vh',
    // overflowY: 'auto'
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/Scroll.tsx
// module id = 382
// module chunks = 0